/* eslint-disable @typescript-eslint/no-explicit-any */

import axios, { AxiosInstance } from 'axios'
import { axios_request } from 'src/axios/base.axios'
import { MOCKED } from 'src/config'
import { to_error } from 'src/error-management'
import { raw_error, raw_response, response_t } from 'src/types'

interface request_args {
  client: AxiosInstance
  request: axios_request
  child?: string
  saga_type?: string
}

export async function do_request<T>({
  client,
  request,
  child = '',
  saga_type = '',
}: request_args): Promise<response_t<T>> {
  const req =
    MOCKED === 'true' && !request?.url?.includes('GestAgenzie-portlet') // TODO
      ? axios.get(to_mock(request))
      : client.request(request)

  return req
    .then((response: raw_response<T> | any) => {
      return { data: child ? response?.data?.[child] : response.data }
    })

    .catch((error: raw_error) => {
      return to_error(error, saga_type)
    })
}

const to_mock = (request: axios_request): string => {
  const BLACKLIST = ['channel', 'startDate', 'language', 'company', 'product', 'effectiveDate']

  const params = Object.entries(request?.params || {})
    ?.filter(([key]) => !BLACKLIST.includes(key))
    ?.map(([key, value]) => `${key}=${value}`)
    ?.join('&')

  const params_ = params ? `?${params}` : ''
  const mock_src = `${request?.url}${params_}`
    ?.slice(1)
    ?.replaceAll('/', '-')
    ?.replaceAll('?', '__')
    ?.replaceAll('&', '-')
    ?.replaceAll(':', '')
    ?.replaceAll('*', 'ast')

  return `/mocks/${mock_src}.json`
}
